module.exports = __webpack_public_path__ + "media/images/gallery/constellations/oc_layer_off-beee5ebc0485f98cedc0c5f52c04b6be.png";